import { Box, Card, Typography } from '@mui/material';
import ArrowButton from '../../../components/button-arrow/ArrowButton';
import { useTheme } from '@mui/material/styles';

export default function AppNavigationBox({
    title,
    subtitle,
    image,
    startIcon,
    handleClick
}) {
    const theme = useTheme();
    const themeGradient = theme.palette.gradients.primary;
    const cardBackground = image ? `url(${image}) no-repeat center center` : themeGradient;
    return (
        <Card
            sx={{
                width: '100%',
                height: '100px',
                borderRadius: '20',
                padding: 2.5,
                background: cardBackground
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                height="100%"
            >
                <Box>
                    <Box display="flex" alignItems="center">
                        {startIcon && startIcon}
                        {title && (
                            <Typography
                                variant="h4"
                                sx={{
                                    color: theme.palette.grey[100],
                                    ml: 1
                                }}
                            >
                                {title}
                            </Typography>
                        )}
                    </Box>
                    {subtitle && (
                        <Typography
                            variant="subtitle1"
                            sx={{ color: theme.palette.grey[100] }}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                <Box>
                    <ArrowButton variant="light" onClick={handleClick} />
                </Box>
            </Box>
        </Card>
    );
}
